exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resize-bar{display:flex;align-items:center;justify-content:center;cursor:col-resize;width:14px;background-color:var(--panel-background);border-right:1px solid var(--lighter-border);border-left:1px solid var(--lighter-border);z-index:65}.resize-bar[data-element=stylePanelResizeBar]{border-color:var(--lighter-border)}", ""]);

// exports
